import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from "@/lib/utils";

// === MOBILE TABS ===

interface MobileTabItem {
  value: string;
  label: string;
  icon?: LucideIcon;
  count?: number;
  disabled?: boolean;
}

interface MobileTabsProps {
  items: MobileTabItem[];
  defaultValue: string;
  children: ReactNode;
  className?: string;
}

export function MobileTabs({ items, defaultValue, children, className }: MobileTabsProps) {
  const cols = items.length;

  return (
    <Tabs defaultValue={defaultValue} className={cn("w-full", className)}>
      <TabsList className={cn(
        "grid w-full h-auto bg-secondary",
        cols === 2 && "grid-cols-2",
        cols === 3 && "grid-cols-3",
        cols === 4 && "grid-cols-4",
        cols === 5 && "grid-cols-5"
      )}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <TabsTrigger
              key={item.value}
              value={item.value}
              disabled={item.disabled}
              className="flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm px-2 py-3 sm:px-3 sm:py-2 min-h-[3rem] sm:min-h-[2.5rem]"
            >
              {Icon && <Icon className="h-4 w-4 flex-shrink-0" />}
              <span className="text-xs sm:text-sm">{item.label}</span>
              {typeof item.count === 'number' && (
                <span className="text-xs sm:text-sm">({item.count})</span>
              )}
            </TabsTrigger>
          );
        })}
      </TabsList>
      {children}
    </Tabs>
  );
}
